import React from 'react';
import { Modal, Button, Form, Input, Comment, Tabs, Avatar, List, Tooltip } from 'antd';

const InputGroup = Input.Group;
const { TabPane } = Tabs;
const { TextArea } = Input;

export default class ViewComent extends React.Component {

    render() {
        return (
            <Modal
                title={"Comentarios"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={900}
                footer={[
                    <>
                        <Button
                            type="danger"
                            icon="stop"
                            onClick={this.props.onClose}
                        >
                            Cerrar
                        </Button>
                        {/*           <Button
                            type="primary"
                            icon="printer"
                        onClick={props.onExportPdf}
                        loading={props.loadingPdf}
                        >
                            Imprimir
                        </Button> */}
                    </>
                ]}
            >
                <Form>

                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                <Input readOnly
                                    value={this.props.formValues.establecimiento}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Vendedor">
                                <Input readOnly
                                    value={this.props.formValues.vendedor}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Nro Crédito">
                                <Input readOnly
                                    value={this.props.formValues.nroContrato}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Nro Contrato">
                                <Input readOnly
                                    value={this.props.formValues.serieDocumento}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">

                            <Form.Item label={this.props.formValues.tipoDocumentoCliente}>
                                <Input readOnly
                                    value={this.props.formValues.numeroDocumentoCliente}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Cliente">
                                <Input readOnly
                                    value={this.props.formValues.razonSocialCliente}
                                />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                {this.props.comments.length > 0 && <List
                                    dataSource={this.props.comments}
                                    header={`${this.props.comments.length} Comentarios `}
                                    itemLayout="vertical"
                                    renderItem={
                                        props => <Comment key={props.id} {...props}
                                            author={<span style={{ fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{props.usuarioRegistro}  - </span>}
                                            avatar={
                                                <Avatar
                                                    src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                                                    alt="Han Solo"
                                                />
                                            }
                                            content={
                                                <p>
                                                    {props.comentario}
                                                </p>
                                            }
                                            datetime={
                                                <Tooltip title={'Fecha registro'}>
                                                    <span style={{ fontWeight: 'bold', color: 'black', textAlign: 'right' }} >{props.fechaRegistro}</span>
                                                </Tooltip>
                                            }
                                        />}
                                />}
                                <Comment
                                    content={
                                        <div>
                                            <Form.Item>
                                                <TextArea
                                                    rows={4}
                                                    onChange={(e) => this.props.onChange(e.target.value.trim())}
                                                    value={this.props.comentario}
                                                    disabled={this.props.formValues.idCreditoEstado == 1 ? false : true}
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <div style={{ width: '100%', textAlign: "right" }}>
                                                    <div className="custom-options">
                                                        <Button
                                                            type="primary"
                                                            icon="save"
                                                            disabled={this.props.comentario.length > 0 ? false : true}
                                                            onClick={this.props.onSave}
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </div>
                                                </div>
                                            </Form.Item>
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                    </div>

                </Form>
            </Modal>
        );
    }
}